import React from 'react';
import { SearchInput } from '@amzn/storm-ui';
import { useTranslation } from 'react-i18next';

interface SearchInputProps {
  value?: string;
  handleOnChangeCb: (value: string) => void;
  placeholder?: string;
  id: string;
}

export const CustomSearchInput: React.FC<SearchInputProps> = ({
  value,
  handleOnChangeCb,
  placeholder,
  id,
}) => {
  const { t } = useTranslation();

  return (
    <SearchInput
      id={id}
      placeholder={placeholder || t('search-input-placeholder')}
      value={value}
      onChange={({ target }) => handleOnChangeCb(target.value)}
      onClear={() => handleOnChangeCb('')}
    />
  );
};
